module.exports = __webpack_public_path__ + "static/media/profile_photo_white.7bf501a4.jpg";